/**
 * Triggers a browser download of a blob under the given filename, handling the
 * object-URL lifecycle (create → click → revoke). Shared by the document/fax
 * download helpers so the DOM dance lives in exactly one place.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
